/**
 * Utility functions for Master Performance board
 */

/**
 * Maps filter options to labels for select inputs
 * @param {Array} options - Array of option objects with label property
 * @returns {Array} Array of labels
 */
export const mapFilterOptions = (options) => {
  const filterOptions = options.map((option) => {
    return option.label;
  });
  return filterOptions;
};

/**
 * Maps filter options to codes for country select
 * @param {Array} options - Array of option objects with code property
 * @returns {Array} Array of codes
 */
export const mapFilterOptionsCode = (options) => {
  const filterOptions = options.map((option) => {
    return option.code;
  });
  return filterOptions;
};

/**
 * Extracts unique values from array by attribute for filter options
 * @param {Array} array - Array of objects
 * @param {string} attribute - Attribute name to extract values from
 * @returns {Array} Array of unique values
 */
export const OptionsFromColumns = (array, attribute) => {
  const valoresUnicos = new Set();
  for (const obj of array) {
    const valor = obj[attribute];
    if (valor !== undefined) {
      valoresUnicos.add(valor);
    }
  }
  return Array.from(valoresUnicos);
};